// @ts-nocheck
import React, { ReactNode, useContext, useState } from "react";

import { Grid } from "antd";
import useMobileDetect from "use-mobile-detect-hook";

export const LAYOUT_MODE = {
  FULLSCREEN: "FULLSCREEN",
  DEFAULT: "DEFAULT",
} as const;

type LayoutMode = (typeof LAYOUT_MODE)[keyof typeof LAYOUT_MODE];

interface LayoutContextValue {
  mode: LayoutMode;
  setMode: React.Dispatch<React.SetStateAction<LayoutMode>>;
  supportedScreens: string[];
  detectMobile: ReturnType<typeof useMobileDetect>;
}

export const LayoutContext = React.createContext<LayoutContextValue>(
  {} as LayoutContextValue,
);

interface LayoutContextProviderProps {
  children: ReactNode;
}

export const LayoutContextProvider = ({
  children,
}: LayoutContextProviderProps) => {
  const [mode, setMode] = useState<LayoutMode>(LAYOUT_MODE.DEFAULT);
  const { useBreakpoint } = Grid;
  const supportedScreens = Object.entries(useBreakpoint())
    .filter(([, supported]) => supported)
    .map(([screen]) => screen);
  const detectMobile = useMobileDetect();
  return (
    <LayoutContext.Provider
      value={{
        mode,
        setMode,
        supportedScreens,
        detectMobile,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
